export default __webpack_public_path__ + "static/brandon-bold-65694b08120169aaec03bb5cecc76252.woff";